module.exports = __webpack_public_path__ + "static/media/ev3.e33da9b4.jpg";